import { Icon, Lightbox } from '@design-system';
import { FC } from 'react';

import { Image } from '../Image';

interface LightboxVideoPlayerProps {
  baseUrl: string;
  handlePlay: () => void;
  poster: string;
  title: string;
  ratio?: '16/9' | '9/16';
  videoId: string | number;
  videoType: 'VIMEO' | 'YOUTUBE';
}

export const LightboxVideoPlayer: FC<LightboxVideoPlayerProps> = ({
  baseUrl,
  handlePlay,
  poster,
  ratio,
  title,
  videoId,
  videoType,
}) => (
  <Lightbox
    items={[
      {
        key: 0,
        media: {
          baseUrl,
          id: videoId?.toString(),
          ratio: ratio || '16/9',
          title,
          type: videoType,
        },
        copyright: undefined,
      },
    ]}
  >
    {(lightbox) => (
      <div className="mx-auto h-full w-full overflow-hidden bg-neutral-6">
        <button
          className="group h-full w-full"
          onClick={() => {
            handlePlay();
            lightbox.openOnSlide(0);
          }}
          type="button"
        >
          <Image
            alt={title}
            hoverEffect
            shape="rounded"
            size={{
              sm: { ratio: '4/3', span: 12 },
              md: { ratio: '3/2', span: 12 },
              lg: { ratio: '3/2', span: 12 },
            }}
            src={poster}
          />
          <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-neutral-6/10">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-white">
              <Icon name="ic_play" size="lg" />
            </div>
          </div>
        </button>
      </div>
    )}
  </Lightbox>
);
